export const TOPIC_MODULE_CATEGORIES = [2, 3, 4, 9, 12, 13];
export const isTopicModule = categoryId => TOPIC_MODULE_CATEGORIES.includes(Number(categoryId));

export function shouldOpenSubjectTopics(subject, toggleEnabled) {
  const forced = Number(subject.forceTopicsEnabled ?? subject.force_topics_enabled) === 1 &&
    Number(subject.forceSubtopicsEnabled ?? subject.force_subtopics_enabled) === 1;
  return forced || (Boolean(toggleEnabled) &&
    Number(subject.subjectTopicVisibilityStatus ?? subject.subject_topic_visibility_status) === 1 &&
    Number(subject.topicsCount ?? subject.topics_count) > 0);
}

export function shouldOpenSubtopics(topicId, childCount, toggleEnabled, forced) {
  return Number(topicId) > 0 && Number(childCount) > 0 && (Boolean(toggleEnabled) || Boolean(forced));
}

export function qbankTopicSelection(topic, mode, toggleEnabled, forced) {
  return mode === 'subtopic'
    ? { selectedSubtopic: topic, sub_topic_id: Number(topic.id), subTopicId: Number(topic.id), topic_id: Number(topic.id),
      is_parent_topic: 0, is_topic_specific: Number(topic.is_topic_specific ?? topic.isTopicSpecific ?? 0), free_paid: '', freeStatus: '' }
    : { selectedTopic: topic, selectedSubtopic: null, sub_topic_id: 0, subTopicId: 0, topic_id: Number(topic.id), is_parent_topic: 1,
      is_topic_specific: 0, ...(!toggleEnabled && !forced ? { free_paid: '', freeStatus: '' } : {}) };
}

export function clearSubjectQuestionContext() {
  return { examFlow: false, exam_id: 0, exams_id: 0, examId: 0, examPlanId: 0, exam_plan_id: 0,
    planDurationId: null, plan_duration_id: null, free_paid: '', freeStatus: '',
    selectedTopic: null, selectedSubtopic: null, topicName: '', topic_name: '', topic_id: 0, sub_topic_id: 0,
    topicRequestParams: null, subTopicRequestParams: null, is_parent_topic: 0, is_topic_specific: 0 };
}

export function questionTopicRequest(flow = {}) {
  const id = Number(flow.topic_id ?? flow.selectedSubtopic?.id ?? flow.selectedTopic?.id ?? 0);
  if (id <= 0 && !flow.selectedTopic && !flow.selectedSubtopic) return {};
  if (!Number.isSafeInteger(id) || id < 0) return {};
  // A selected zero-ID topic is the API's Miscellaneous bucket, not an absent filter.
  return { topic_id: id,
    is_parent_topic: Number(flow.is_parent_topic || 0),
    is_topic_specific: Number(flow.is_topic_specific || 0) };
}



export function contentTopicRequest(flow = {}) {
  const examId = Number(flow.exam_id || flow.examId || flow.exams_id || 0);
  return { ...questionTopicRequest(flow), ...(examId > 0 ? { exam_id: examId } : {}) };
}
